import PropertyService from "./propertyService.js";
import { CATEGORIES } from "./consts.js";

/**
 * 地図検索ページの状態管理クラス
 * DOM参照・URLハッシュ解析・フェッチフロー・ローディング制御を一元管理する
 */
class MapStateManager {
    constructor() {
        this.elements = {
            root: document.querySelector(".js-search-map"),
            propertyContainer: document.querySelector(
                ".js-search-map__property-container"
            ),
            select: document.querySelector(".js-search-map__select select"),
            loading: document.querySelector(".js-search-map__loading"),
            count: document.querySelector(".js-search-map__count"),
            searchButton: document.querySelector(
                ".js-search-map__search-button"
            ),
            toggleButton: document.querySelector(
                ".js-search-map__toggle-button"
            ),
            menu: document.querySelector(".js-search-map__menu"),
        };

        // 重複リクエスト防止フラグ
        this._isFetching = false;
    }

    // URLハッシュから物件種別を取得（デフォルト: "all"）
    getPropertyType() {
        return window.location.hash.slice(1) || "all";
    }

    // 物件種別から取引種別を判定
    getTransactionType() {
        const type = this.getPropertyType();
        return type === CATEGORIES.INVEST ? "rent" : "buy";
    }

    // URLハッシュに基づいてセレクトボックスの値を同期
    syncSelectFromHash() {
        if (!this.elements.select) return;
        this.elements.select.value = this.getPropertyType();
    }

    // 認証状態を取得
    isAuthenticated() {
        const el = document.querySelector(".js-search-map__is-authenticated");
        return el ? el.hasAttribute("data-auth") : false;
    }

    // ローディング表示
    showLoading() {
        this.elements.loading?.removeAttribute("data-hidden");
    }

    // ローディング非表示
    hideLoading() {
        this.elements.loading?.setAttribute("data-hidden", "");
    }

    // メニューを開く
    openMenu() {
        this.elements.toggleButton?.setAttribute("data-open", "true");
        this.elements.menu?.setAttribute("data-active", "");
    }

    // bounds取得 → fetch → マーカー更新の統一フロー
    async fetchAndUpdateMarkers(map, markerManager) {
        if (this._isFetching) return;

        const bounds = map.getBounds();
        if (!bounds) return;

        this._isFetching = true;
        this.showLoading();

        try {
            const northEast = bounds.getNorthEast();
            const southWest = bounds.getSouthWest();
            const type = this.getPropertyType();

            const data = await PropertyService.fetchPropertiesInBounds(
                type,
                southWest.lat(),
                northEast.lat(),
                southWest.lng(),
                northEast.lng()
            );

            await markerManager.updateMarkers(data);
        } catch (error) {
            console.error("物件データの取得に失敗しました:", error);
        } finally {
            this.hideLoading();
            this._isFetching = false;
        }
    }
}

export default MapStateManager;
